<template>
    <div class="expert-seminar-add">
        <bread-crumb :bread-list="breadList" />
        <div class="add-content">
            <div class="title-wrap">
                <i class="iconfont icon-tongyongbiaotiicon"></i>
                <span class="title-text">创建课程</span>
            </div>
            <el-form :model="addForm"
                     ref="addForm"
                     class="banner-form type-form">
                <div class="info-warp">
                    <el-divider direction="vertical"></el-divider>
                    <span class="info-text">课程类型</span>
                </div>
                <el-row>
                    <el-col :span="24"
                            style="border-bottom: 1px solid #ccc;">
                        <el-form-item label="课程类型"
                                      prop="type"
                                      label-width="130px"
                                      :rules="[{ required: true, message: '请选择课程类型', trigger: 'change' }]">
                            <el-radio-group v-model="addForm.type">
                                <el-radio label="1">原创内容</el-radio>
                                <el-radio label="2">外链内容</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <el-form :model="addForm"
                     v-show="addForm.type==='1'"
                     ref="addForm"
                     v-loading="loading"
                     class="banner-form">
                <div class="info-warp">
                    <el-divider direction="vertical"></el-divider>
                    <span class="info-text">课程信息</span>
                </div>
                <el-row>
                    <el-col :span="10">
                        <el-form-item label="课程名称"
                                      prop="title"
                                      label-width="130px"
                                      :rules="[{ required: true, message: '请输入课程名称', trigger: 'change' }]">
                            <el-input v-model.trim="addForm.title"
                                      class="from-input"
                                      placeholder="请输入课程名称"
                                      maxlength="50">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="14">
                        <el-form-item label="价格"
                                      prop="price"
                                      label-width="130px"
                                      :rules="[{ required: true, message: '请输入价格', trigger: 'change' }]">
                            <el-input v-model="addForm.price"
                                      class="from-input"
                                      type="number"
                                      placeholder="请输入价格"
                                      @input.native="handleInput">
                            </el-input>
                            <span class="item_text">元</span>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="10">
                        <el-form-item label="关联视频"
                                      prop="videoId"
                                      label-width="130px"
                                      :rules="[{ required: true, message: '请输入关联视频名称', trigger: 'change' }]">
                            <el-select filterable
                                       clearable
                                       remote
                                       :remote-method="getVideoList"
                                       :loading="videoLoading"
                                       loading-text="正在搜索关联视频，请稍后..."
                                       v-model="addForm.videoId"
                                       placeholder="请输入关联视频名称"
                                       class="form-select"
                                       @change="handleVideoSelect"
                                       @clear="handleVideoSelect">
                                <el-option v-for="item in videoList"
                                           :label="item.videoName"
                                           :value="item.videoId"
                                           :key="item.videoId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="14">
                        <el-form-item label="视频ID"
                                      label-width="130px">
                            <el-input class="from-input"
                                      v-model="addForm.videoId"
                                      value="暂无"
                                      disabled>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="10">
                        <el-form-item label="视频名称"
                                      label-width="130px">
                            <el-input class="from-input"
                                      v-model="addForm.videoName"
                                      value="暂无"
                                      disabled>
                            </el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="10">
                        <el-form-item label="关联栏目"
                                      prop="programId"
                                      label-width="130px"
                                      :rules="[{ required: true, message: '请输入关联栏目名称', trigger: 'change' }]">
                            <el-select filterable
                                       clearable
                                       remote
                                       :remote-method="getProgramList"
                                       :loading="programLoading"
                                       loading-text="正在搜索关联栏目，请稍后..."
                                       v-model="addForm.programId"
                                       placeholder="请输入关联栏目名称"
                                       class="form-select"
                                       @change="handleProgramSelect"
                                       @clear="handleProgramSelect">
                                <el-option v-for="item in programList"
                                           :label="item.programName"
                                           :value="item.programId"
                                           :key="item.programId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="10">
                        <el-form-item label="封面图"
                                      label-width="130px"
                                      prop="pictureId"
                                      :rules="[{ required: true, message: '请上传封面图', trigger: 'change' }]">
                            <div class="picture-item">
                                <div v-if="addForm.pictureId"
                                     class="cover-content">
                                    <el-image fit="fill"
                                              class="cover-picture"
                                              :src="'/ms-hoc-video/v1/image/download?fileName='+ addForm.pictureId">
                                    </el-image>
                                    <i class="iconfont icon-jinggaochacha"
                                       @click="handleRemove"></i>
                                </div>

                                <el-upload v-else
                                           v-loading="pictureLoading"
                                           class="picture-uploader"
                                           :action="uploadAction"
                                           :show-file-list="false"
                                           accept=".jpg, .png"
                                           :on-success="handleSuccess"
                                           :before-upload="beforeUpload">
                                    <div class="picture-content">
                                        <i class="iconfont icon-camera"></i>
                                        <div class="picture_text">
                                            上传封面图
                                        </div>
                                    </div>
                                </el-upload>
                                <span class="uploader-tips">
                                    建议图片小于2M，尺度240*160；图片格式为JPG、PNG。
                                </span>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="24"
                            style="border-bottom: 1px solid #ccc;">
                        <el-form-item label="课程简介"
                                      label-width="130px"
                                      prop="videoDescription"
                                      :rules="[{ required: true, message: '请输入课程简介', trigger: 'change' }]">
                            <el-input v-model.trim="addForm.videoDescription"
                                      class="from-textarea"
                                      :autosize="{ minRows: 2, maxRows: 4}"
                                      type="textarea"
                                      maxlength="150"
                                      show-word-limit
                                      placeholder="请输入课程简介">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <div class="info-warp">
                    <el-divider direction="vertical"></el-divider>
                    <span class="info-text">来源信息</span>
                </div>

                <el-row>
                    <el-col :span="10">
                        <el-form-item label="来源"
                                      prop="doctorId"
                                      label-width="130px"
                                      :rules="[{ required: true, message: '请输入姓名或者手机号', trigger: 'change' }]">
                            <el-select filterable
                                       clearable
                                       remote
                                       :remote-method="getDoctorList"
                                       :loading="doctorLoading"
                                       loading-text="正在搜索，请稍后..."
                                       v-model="addForm.doctorId"
                                       placeholder="请输入姓名或者手机号"
                                       class="form-select"
                                       @change="handleDoctorSelect"
                                       @clear="handleDoctorSelect">
                                <el-option v-for="item in doctorList"
                                           :label="item.accountName"
                                           :value="item.iuid"
                                           :key="item.iuid">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="14">
                        <el-form-item label="执业点"
                                      label-width="130px">
                            <el-input v-model="addForm.hospitalName"
                                      class="from-input"
                                      disabled>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="10">
                        <el-form-item label="科室"
                                      label-width="130px">
                            <el-input v-model="addForm.deptName"
                                      class="from-input"
                                      disabled>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="14">
                        <el-form-item label="姓名"
                                      label-width="130px">
                            <el-input v-model="addForm.doctorName"
                                      class="from-input"
                                      disabled>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="10">
                        <el-form-item label="职称"
                                      label-width="130px">
                            <el-input v-model="addForm.doctorTitle"
                                      class="from-input"
                                      disabled>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label-width="130px">
                            <el-button type="primary"
                                       class="submit-btn"
                                       @click="submitForm('addForm')">提交</el-button>
                            <el-button @click="handleCandle"
                                       class="cancle-btn">取消</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <el-form :model="outForm"
                     v-show="addForm.type==='2'"
                     ref="outForm"
                     v-loading="loading"
                     class="banner-form">
                <div class="info-warp">
                    <el-divider direction="vertical"></el-divider>
                    <span class="info-text">课程信息</span>
                </div>
                <el-row>
                    <el-col :span="10">
                        <el-form-item label="课程名称"
                                      prop="title"
                                      label-width="130px"
                                      :rules="[{ required: true, message: '请输入课程名称', trigger: 'change' }]">
                            <el-input v-model.trim="outForm.title"
                                      class="from-input"
                                      placeholder="请输入课程名称"
                                      maxlength="50">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="关联栏目"
                                      prop="programId"
                                      label-width="130px"
                                      :rules="[{ required: true, message: '请输入关联栏目名称', trigger: 'change' }]">
                            <el-select filterable
                                       clearable
                                       remote
                                       :remote-method="getOutProgramList"
                                       :loading="programLoading"
                                       loading-text="正在搜索关联栏目，请稍后..."
                                       v-model="outForm.programId"
                                       placeholder="请输入关联栏目名称"
                                       class="form-select"
                                       @change="handleOutProgramSelect"
                                       @clear="handleOutProgramSelect">
                                <el-option v-for="item in programListOut"
                                           :label="item.programName"
                                           :value="item.programId"
                                           :key="item.programId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="10">
                        <el-form-item label="封面图"
                                      label-width="130px"
                                      prop="pictureId"
                                      :rules="[{ required: true, message: '请上传封面图', trigger: 'change' }]">
                            <div class="picture-item">
                                <div v-if="outForm.pictureId"
                                     class="cover-content">
                                    <el-image fit="fill"
                                              class="cover-picture"
                                              :src="'/ms-hoc-video/v1/image/download?fileName='+ outForm.pictureId">
                                    </el-image>
                                    <i class="iconfont icon-jinggaochacha"
                                       @click="handleRemoveOut"></i>
                                </div>

                                <el-upload v-else
                                           v-loading="pictureLoading"
                                           class="picture-uploader"
                                           :action="uploadAction"
                                           :show-file-list="false"
                                           accept=".jpg, .png"
                                           :on-success="handleSuccessOut"
                                           :before-upload="beforeUpload">
                                    <div class="picture-content">
                                        <i class="iconfont icon-camera"></i>
                                        <div class="picture_text">
                                            上传封面图
                                        </div>
                                    </div>
                                </el-upload>
                                <span class="uploader-tips">
                                    建议图片小于2M，尺度240*160；图片格式为JPG、PNG。
                                </span>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="24"
                            style="border-bottom: 1px solid #ccc;">
                        <el-form-item label="关联视频URL"
                                      prop="externalUrl"
                                      label-width="130px"
                                      :rules="[{ required: true, message: '请输入关联视频URL', trigger: 'change' }]">
                            <el-input v-model.trim="outForm.externalUrl"
                                      class="from-input"
                                      placeholder="请输入关联视频URL"
                                      maxlength="500">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <div class="info-warp">
                    <el-divider direction="vertical"></el-divider>
                    <span class="info-text">来源信息</span>
                </div>

                <el-row>
                    <el-col :span="24">
                        <el-form-item label="来源"
                                      prop="expertFrom"
                                      label-width="130px"
                                      :rules="[{ required: true, message: '请输入来源', trigger: 'change' }]">
                            <el-input v-model.trim="outForm.expertFrom"
                                      class="from-input"
                                      placeholder="请输入来源"
                                      maxlength="30">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label-width="130px">
                            <el-button type="primary"
                                       class="submit-btn"
                                       @click="submitForm('outForm')">提交</el-button>
                            <el-button @click="handleCandle"
                                       class="cancle-btn">取消</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { postVideoList } from '@/api/video'
import { postProgramList } from '@/api/program'
import { postPhoneOrName, postExpertseminar } from '@/api/expert'
export default {
    name: 'expertSeminarAdd',
    data () {
        return {
            breadList: [{ label: '内容管理' }, { label: '医空间', path: '/content/expertSeminar' }, { label: '创建课程' }],
            loading: false,
            pictureLoading: false,
            videoLoading: false,
            programLoading: false,
            doctorLoading: false,
            videoList: [],
            programList: [],
            programListOut: [],
            doctorList: [],
            addForm: {
                type: '1',
                title: '',
                price: '',
                pictureId: '',
                videoId: '',
                videoName: '',
                doctorId: '',
                doctorName: '',
                doctorTitle: '',
                hospitalId: '',
                hospitalName: '',
                deptId: '',
                deptName: '',
                videoDescription: '',
                programId: '',
                programName: ''
            },
            outForm: {
                title: '',
                programId: '',
                programName: '',
                pictureId: '',
                // 外链
                externalUrl: '', // 关联视频url
                expertFrom: '' // 外链来源
            }
        }
    },
    computed: {
        ...mapGetters([
            'userInfo'
        ]),
        uploadAction () {
            return `/ms-hoc-video/v1/image/upload?hospitalId=${this.userInfo.hospitalId}&iuid=${this.userInfo.iuid}&ImageType=EXPERTSEMINAR`
        }
    },
    methods: {
        handleInput (e) {
            // 通过正则过滤小数点后两位
            e.target.value = (e.target.value.match(/^\d*(\.?\d{0,2})/g)[0]) || null
        },
        handleCandle () {
            this.$router.push('/content/expertSeminar')
        },
        beforeUpload (file) {
            this.pictureLoading = true
            return true
        },
        handleSuccess (res, file) {
            let data = res.results
            if (data && data.length > 0) {
                this.addForm.pictureId = data[0].originPictureId
                this.$refs['addForm'].clearValidate()
            } else {
                this.$message.error('上传出错，请检查上传图片！')
            }

            this.pictureLoading = false
        },
        handleRemoveOut () {
            this.outForm.pictureId = ''
            this.pictureLoading = false
        },
        handleSuccessOut (res, file) {
            let data = res.results
            if (data && data.length > 0) {
                this.outForm.pictureId = data[0].originPictureId
                this.$refs['outForm'].clearValidate()
            } else {
                this.$message.error('上传出错，请检查上传图片！')
            }

            this.pictureLoading = false
        },
        handleRemove () {
            this.addForm.pictureId = ''
            this.pictureLoading = false
        },
        async getVideoList (value) {
            if (value) {
                let params = {
                    videoNameOrId: value,
                    current: 1,
                    size: 100
                }
                this.videoLoading = true
                const { results } = await postVideoList(params)
                this.videoList = results
                this.videoLoading = false
            } else {
                this.videoList = []
            }
        },
        handleVideoSelect (value) {
            if (value) {
                let obj = {}
                obj = this.videoList.find(item => {
                    return item.videoId === value
                })
                this.addForm.videoName = obj.videoName
                this.addForm.videoId = value
            } else {
                this.addForm.videoName = ''
                this.addForm.videoId = ''
                this.deptList = []
            }
        },

        async getProgramList (value) {
            if (value) {
                let params = {
                    programName: value,
                    current: 1,
                    size: 100
                }
                this.programLoading = true
                const { results } = await postProgramList(params)
                this.programList = results
                this.programLoading = false
            } else {
                this.programList = []
            }
        },
        handleProgramSelect (value) {
            if (value) {
                let obj = {}
                obj = this.programList.find(item => {
                    return item.programId === value
                })
                this.addForm.programName = obj.programName
                this.addForm.programId = value
            } else {
                this.addForm.programName = ''
                this.addForm.programId = ''
                this.programList = []
            }
        },
        async getOutProgramList (value) {
            if (value) {
                let params = {
                    programName: value,
                    current: 1,
                    size: 100
                }
                this.programLoading = true
                const { results } = await postProgramList(params)
                this.programListOut = results
                this.programLoading = false
            } else {
                this.programListOut = []
            }
        },
        handleOutProgramSelect (value) {
            if (value) {
                let obj = {}
                obj = this.programListOut.find(item => {
                    return item.programId === value
                })
                this.outForm.programName = obj.programName
                this.outForm.programId = value
            } else {
                this.outForm.programName = ''
                this.outForm.programId = ''
                this.programListOut = []
            }
        },

        async getDoctorList (value) {
            if (value) {
                let params = {
                    phoneOrName: value,
                    current: 1,
                    size: 100
                }
                this.doctorLoading = true
                const { results } = await postPhoneOrName(params)
                this.doctorList = results
                this.doctorLoading = false
            } else {
                this.doctorList = []
            }
        },
        handleDoctorSelect (value) {
            if (value) {
                let obj = {}
                obj = this.doctorList.find(item => {
                    return item.iuid === value
                })
                this.addForm.doctorName = obj.accountName
                this.addForm.doctorId = value
                this.addForm.doctorTitle = obj.titleName
                this.addForm.hospitalId = obj.hospitalId
                this.addForm.hospitalName = obj.hospitalName
                if (obj.departmentVO) {
                    this.addForm.deptId = obj.departmentVO.groupId
                    this.addForm.deptName = obj.departmentVO.groupName
                } else {
                    this.addForm.deptId = ''
                    this.addForm.deptName = ''
                }
            } else {
                this.addForm.deptId = ''
                this.addForm.deptName = ''
                this.addForm.doctorName = ''
                this.addForm.doctorId = ''
                this.addForm.doctorTitle = ''
                this.addForm.hospitalId = ''
                this.addForm.hospitalName = ''
                this.doctorList = []
            }
        },
        submitForm (formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.addExpertseminar(formName)
                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        },
        async addExpertseminar (type) {
            let params
            if (type === 'outForm') {
                params = {
                    creatorUserId: this.userInfo.iuid,
                    creatorUserName: this.userInfo.accountName,
                    seminarType: this.addForm.type,
                    title: this.outForm.title,
                    pictureId: this.outForm.pictureId,
                    programName: this.outForm.programName,
                    programId: this.outForm.programId,
                    externalUrl: this.outForm.externalUrl,
                    expertFrom: this.outForm.expertFrom
                }
            } else {
                params = {
                    seminarType: this.addForm.type,
                    title: this.addForm.title,
                    price: this.addForm.price,
                    pictureId: this.addForm.pictureId,
                    videoId: this.addForm.videoId,
                    videoName: this.addForm.videoName,
                    doctorId: this.addForm.doctorId,
                    doctorName: this.addForm.doctorName,
                    doctorTitle: this.addForm.doctorTitle,
                    hospitalId: this.addForm.hospitalId,
                    videoDescription: this.addForm.videoDescription,
                    hospitalName: this.addForm.hospitalName,
                    deptId: this.addForm.deptId,
                    deptName: this.addForm.deptName,
                    creatorUserId: this.userInfo.iuid,
                    creatorUserName: this.userInfo.accountName,
                    programName: this.addForm.programName,
                    programId: this.addForm.programId
                }
            }
            this.loading = true
            const { state } = await postExpertseminar(params)
            this.loading = false
            if (state === 200) {
                this.$message({
                    message: '新增课程成功',
                    customClass: 'hos-message--success',
                    iconClass: 'el-icon-success',
                    duration: '1000'
                })
                this.$router.push('/content/expertSeminar')
            }
        }
    }
}
</script>

<style lang="scss">
.expert-seminar-add {
    height: 100%;
    .add-content {
        min-height: calc(100% - 95px);
        box-shadow: 0 1px 4px 0 rgba(202, 202, 202, 0.5);
        margin: 20px;
        padding: 20px 20px 0 20px;
        background: #fff;
        .title-wrap {
            font-size: 0;
            padding-bottom: 10px;
            height: 16px;
            line-height: 16px;
            border-bottom: 1px solid #ccc;
            .icon-tongyongbiaotiicon {
                color: $color-primary;
                font-size: 16px;
                vertical-align: middle;
            }
            .title-text {
                font-size: 14px;
                color: #333333;
                margin-left: 10px;
                display: inline-block;
                height: 16px;
                line-height: 16px;
                vertical-align: middle;
            }
        }
        .info-warp {
            display: flex;
            align-items: center;
            margin: 20px 0;
            .el-divider--vertical {
                width: 4px;
                background: #06aea6;
                margin: 0;
            }
            .info-text {
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #333333;
                text-align: left;
                line-height: 14px;
                margin-left: 10px;
            }
        }

        .banner-form {
            .el-form-item__label {
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #666666;
                letter-spacing: 0;
                padding-right: 20px;
            }
            .el-form-item__content {
                .el-input__prefix {
                    .el-input__icon {
                        line-height: 32px;
                    }
                }
                .el-input__suffix {
                    .el-input__icon {
                        line-height: 32px;
                    }
                }
                .form-auto {
                    .el-input {
                        width: 320px;
                        .el-input__inner {
                            border-radius: 3px;
                            border: 1px solid #dcdcdc;
                            height: 32px;
                            padding: 0 10px;
                        }
                    }
                }
                .from-input {
                    width: 320px;
                    .el-input__inner {
                        border-radius: 3px;
                        border: 1px solid #dcdcdc;
                        height: 32px;
                        padding: 0 10px;
                    }
                }
                .item_text {
                    font-family: PingFangSC-Regular;
                    font-size: 14px;
                    color: #666666;
                    letter-spacing: 0;
                    line-height: 14px;
                    margin-left: 10px;
                }
                .form-select {
                    .el-input {
                        width: 320px;
                        .el-input__inner {
                            border-radius: 3px;
                            border: 1px solid #dcdcdc;
                            height: 32px;
                            padding: 0 10px;
                        }
                    }
                }
                .from-textarea {
                    .el-textarea__inner {
                        padding: 5px 10px;
                        width: 720px;
                        height: 132px !important;
                        border: 1px solid #dcdcdc;
                        border-radius: 3px;
                    }
                    .el-input__count {
                        font-family: PingFangSC-Regular;
                        font-size: 14px;
                        color: #cccccc;
                        letter-spacing: 0;
                        right: 0;
                        left: 660px;
                        bottom: 0px;
                        background: none;
                    }
                }
                .picture-item {
                    position: relative;
                    .cover-content {
                        position: relative;
                        height: 80px;
                        .cover-picture {
                            width: 120px;
                            height: 80px;
                        }
                        .icon-jinggaochacha {
                            cursor: pointer;
                            font-size: 16px;
                            color: #ec6a69;
                            position: absolute;
                            top: -15px;
                            left: 110px;
                        }
                    }
                    .picture-uploader {
                        width: 120px;
                        height: 80px;
                        background: #d8d8d8;
                        text-align: center;
                        .picture-content {
                            margin-top: 10px;
                            .icon-camera {
                                font-size: 24px;
                                color: #fff;
                            }
                            .picture_text {
                                margin-top: 2px;
                                font-family: PingFang-SC-Medium;
                                font-size: 14px;
                                color: #ffffff;
                                letter-spacing: 0;
                                line-height: 14px;
                            }
                        }
                    }
                    .uploader-tips {
                        font-family: PingFangSC-Regular;
                        font-size: 12px;
                        color: #999999;
                        letter-spacing: 0;
                        line-height: 16px;
                        display: inline-block;
                        position: absolute;
                        left: 130px;
                        top: 0;
                        width: 200px;
                        text-align: left;
                    }
                }

                .submit-btn {
                    width: 100px;
                    height: 32px;
                    border-radius: 3px;
                    padding: 0;
                }
                .cancle-btn {
                    width: 100px;
                    height: 32px;
                    border-radius: 3px;
                    padding: 0;
                    background: #f5f5f5;
                    border: 1px solid #cccccc;
                    color: #666;
                    margin-left: 16px;
                }
            }
        }
        .type-form {
            .el-form-item__label {
                line-height: 14px;
                height: 14px;
            }
            .el-form-item__content {
                line-height: 14px;
            }
        }
    }
}
</style>
